// extracted by css-extract-rspack-plugin
export default {"addHealthCheckupInstitutionButton":"AddHealthCheckupInstitution__addHealthCheckupInstitutionButton--PwE2k"};